export const matchNameToObject = (
  name: string,
  list: { name: string; id: string }[],
): string | null => {
  const clean = name.trim().toLowerCase();

  const fullMatch = list.find((obj) => obj.name.trim().toLowerCase() === clean);

  if (fullMatch) return fullMatch.id;

  const partialMatch = list.find((obj) => {
    const objName = obj.name.trim().toLowerCase();

    if (objName.includes(clean) || clean.includes(objName)) {
      return true;
    }

    return false;
  });

  return partialMatch?.id || null;
};
